import { isFeatureEnabled } from '../featureToggles.module'

const _getters = {
  canUseHackathon2025Screen: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'hackathon-2025')
  },
}

export default _getters
